import { useEffect, useState } from 'react';

/**
 * Delays the summary sheet "open" class until after mount so CSS translateY can animate.
 */
export const useStoreCartSummarySheetAnimation = (isOpen: boolean): boolean => {
  const [isEntered, setIsEntered] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsEntered(false);
      return undefined;
    }

    const frameId = requestAnimationFrame(() => {
      setIsEntered(true);
    });

    return () => cancelAnimationFrame(frameId);
  }, [isOpen]);

  return isEntered;
};
